import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  getBanners,
  updateBanner,
  insertBanner,
  deleteBanner,
  getBannerById,
  updateActivarBanner,
  getBannersDiasSemana,
  updateBannerSemana,
  getBannerSemanaByIdiomaId,
} from 'services/configuracionPortal'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_BANNERS() {
  try {
    const bannersData = yield call(getBanners)
    if (bannersData.ok) {
      yield put({
        type: actions.BANNERS_LOAD_SUCCEEDED,
        payload: bannersData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar banners')
      put({
        type: actions.BANNERS_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.BANNERS_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_BANNERS_DIAS_SEMANA(action) {
  try {
    const bannersData = yield call(getBannersDiasSemana, action.payload)
    if (bannersData.ok) {
      yield put({
        type: actions.BANNERS_DIAS_SEMANA_LOAD_SUCCEEDED,
        payload: bannersData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar banners días semana')
      put({
        type: actions.BANNERS_DIAS_SEMANA_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.BANNERS_DIAS_SEMANA_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_BANNER(action) {
  try {
    const bannerObj = yield call(insertBanner, action.payload)
    if (bannerObj.ok) {
      putMessage(messageType.SUCCESS, 'Banner creado correctamente')
      yield put({
        type: actions.BANNER_INSERT_SUCCEEDED,
        payload: bannerObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear Banner')
      yield put({
        type: actions.BANNER_INSERT_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear Banner')
    yield all([
      put({
        type: actions.BANNER_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_BANNER(action) {
  try {
    const bannerObj = yield call(updateBanner, action.payload)
    if (bannerObj.ok) {
      putMessage(messageType.SUCCESS, 'Banner modificado correctamente')
      yield put({
        type: actions.BANNER_UPDATE_SUCCEEDED,
        payload: bannerObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Banner')
      yield put({
        type: actions.BANNER_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Banner')
    yield all([
      put({
        type: actions.BANNER_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_BANNER(action) {
  try {
    const bannerResult = yield call(deleteBanner, action.payload)
    if (bannerResult.ok) {
      putMessage(messageType.SUCCESS, 'Banner eliminado correctamente')
      yield put({
        type: actions.BANNER_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar Banner')
      yield put({
        type: actions.BANNER_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar País')
    yield all([
      put({
        type: actions.BANNER_DELETE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_BANNER_BY_ID(action) {
  try {
    const bannerData = yield call(getBannerById, action.payload)
    if (bannerData.ok) {
      yield put({
        type: actions.BANNER_BYID_LOAD_SUCCEEDED,
        payload: bannerData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar categoria')
      put({
        type: actions.BANNER_BYID_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.BANNER_BYID_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_ACTIVAR_BANNER(action) {
  try {
    const bannerObj = yield call(updateActivarBanner, action.payload)
    if (bannerObj.ok) {
      putMessage(messageType.SUCCESS, 'Banner activado correctamente')
      yield put({
        type: actions.BANNER_ACTIVAR_UPDATE_SUCCEEDED,
        payload: bannerObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al activar Banner')
      yield put({
        type: actions.BANNER_ACTIVAR_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al activar Banner')
    yield all([
      put({
        type: actions.BANNER_ACTIVAR_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_BANNER_SEMANA(action) {
  try {
    const bannerSemanaObj = yield call(updateBannerSemana, action.payload)
    if (bannerSemanaObj.ok) {
      putMessage(messageType.SUCCESS, 'Banner Semana modificado correctamente')
      yield put({
        type: actions.BANNER_SEMANA_UPDATE_SUCCEEDED,
        payload: action.payload.activado,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Banner Semana')
      yield put({
        type: actions.BANNER_SEMANA_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Banner Semana')
    yield all([
      put({
        type: actions.BANNER_SEMANA_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_BANNER_SEMANA_ACTIVO(action) {
  try {
    const bannerSemanaData = yield call(getBannerSemanaByIdiomaId, action.payload)
    if (bannerSemanaData.ok) {
      yield put({
        type: actions.BANNER_SEMANA_BY_IDIOMA_ID_LOAD_SUCCEEDED,
        payload: bannerSemanaData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar banner semana activo')
      put({
        type: actions.BANNER_SEMANA_BY_IDIOMA_ID_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.BANNER_SEMANA_BY_IDIOMA_ID_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.BANNERS_LOAD_REQUESTED, GET_BANNERS),
    takeEvery(actions.BANNER_INSERT_REQUESTED, INSERT_BANNER),
    takeEvery(actions.BANNER_UPDATE_REQUESTED, UPDATE_BANNER),
    takeEvery(actions.BANNER_DELETE_REQUESTED, DELETE_BANNER),
    takeEvery(actions.BANNER_BYID_LOAD_REQUESTED, GET_BANNER_BY_ID),
    takeEvery(actions.BANNER_ACTIVAR_UPDATE_REQUESTED, UPDATE_ACTIVAR_BANNER),
    takeEvery(actions.BANNERS_DIAS_SEMANA_LOAD_REQUESTED, GET_BANNERS_DIAS_SEMANA),
    takeEvery(actions.BANNER_SEMANA_UPDATE_REQUESTED, UPDATE_BANNER_SEMANA),
    takeEvery(actions.BANNER_SEMANA_BY_IDIOMA_ID_LOAD_REQUESTED, GET_BANNER_SEMANA_ACTIVO),
  ])
}
